import script from "./MemberInfoHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberInfoHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MemberInfoHeader.vue?vue&type=style&index=0&id=50f363aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f363aa"]])

export default __exports__